import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const INFINITE_DONATION_SURVEYS_QUERY_KEY = 'survey/donation';

export function useInfiniteDonationSurveys({
	shouldIncludeArchived = false,
	shouldIncludeExpired = false,
	search = '',
	pageSize = 100,
	enabled = true,
	impersonationContext,
}: {
	shouldIncludeArchived?: boolean;
	shouldIncludeExpired?: boolean;
	search?: string;
	pageSize?: number;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	transformer?: (page: Api.IPagedCollection<Api.IDonationSurvey>) => Api.IPagedCollection<Api.IDonationSurvey>;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IDonationSurvey>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			const page = await userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IDonationSurvey>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: {
						includeArchived: shouldIncludeArchived,
						includeExpired: shouldIncludeExpired,
						search,
						pageSize,
						pageToken: pageParam,
					},
					urlPath: `survey/donation`,
				}),
				'GET',
				null
			);

			return page;
		},
		queryKey: [
			INFINITE_DONATION_SURVEYS_QUERY_KEY,
			shouldIncludeArchived,
			shouldIncludeExpired,
			search,
			pageSize,
			enabled,
			impersonationContext,
		],
		initialPageParam: '',
	});
}

export const invalidateInfiniteDonationSurveys = () => {
	reactQueryClient.invalidateQueries({ queryKey: [INFINITE_DONATION_SURVEYS_QUERY_KEY] });
};
